"use client";

type MessagesProps = {
  error?: string;
  message?: string;
};

export default function Messages({ error, message }: MessagesProps) {
  return (
    <>
      {error && (
        <p className="mt-4 p-2 text-sm bg-neutral-900 text-white text-center w-full max-w-md mx-auto">
          {error}
        </p>
      )}
      {message && (
        <p className="mt-4 p-2 text-sm bg-neutral-900 text-white text-center w-full max-w-md mx-auto">
          {message}
        </p>
      )}
    </>
  );
}
